export default "__VITE_ASSET__ZR0pZHvG__"